@if (column(); as column) {
  <div class="relative pt-2">
    <div
      class="flex flex-row items-center h-[56px] mb-1 rounded px-8 gap-3 hover:bg-secondary-100 focus-within:[outline:1px_solid_var(--color-primary)] focus-within:[outline-offset:-1px]"
    >
      <div class="w-[4px] h-[24px] rounded-full shrink-0" [style.background-color]="column.color"></div>

      <input
        #titleInput
        class="text-base font-semibold text-secondary-900 [field-sizing:content] min-w-[1ch] max-w-full w-auto outline-none border-0 bg-transparent"
        (blur)="handleBlur()"
        (keydown.enter)="titleInput.blur()"
        placeholder="Untitled"
        [readonly]="!!section() && column.id !== 'temp'"
        [formControl]="columnForm().controls.title"
      />

      @if (count()) {
        <span class="text-base font-normal text-secondary-500">{{ count() }}</span>
      }

      <div class="flex-1"></div>

      @if (section(); as section) {
        <div
          class="bg-primary-400 h-[20px] w-fit max-w-[120px] rounded-[4px] text-white flex items-center justify-center px-[8px] shrink-0"
        >
          <span class="truncate text-sm font-medium">{{ section.title || 'Section ' + sectionPositionLabel() }}</span>
        </div>
      }

      @if (column.id) {
        <app-button2
          class="rotate-90"
          appearance="secondary-ghost"
          size="s"
          matTooltip="More options"
          stchPopoverTrigger="click"
          [appProjectBoardColumnContextMenu]="column"
          [appProjectBoardColumnContextMenuSection]="section()"
          [appProjectBoardColumnContextMenuOrientation]="'vertical'"
        >
          <app-icon name="sapphire-ellipsis" />
        </app-button2>

        <app-button2 appearance="secondary-ghost" size="s" (click)="toggleCollapse()">
          <app-icon name="chevron-down" class="transition-transform" [class.-rotate-90]="collapsed()" />
        </app-button2>
      }
    </div>

    <div
      class="grid transition-[grid-template-rows] duration-300 ease-in-out"
      [style.gridTemplateRows]="collapsed() && !dragging() ? '0fr' : '1fr'"
    >
      <div
        class="flex flex-col rounded overflow-hidden min-h-0 transition-colors"
        [ngClass]="dragging() ? 'outline-1 outline-dashed outline-blue-200 outline-offset-[-1px]' : ''"
        [style.minHeight.px]="tasks().length === 0 && dragging() ? 40 : null"
        appDroppable
        appDroppableHoverClass="bg-blue-50"
        [appDroppableHoverOnly]="dndEnabled()"
        [appDroppableNoReposition]="true"
        [appDroppableZIndex]="dndEnabled() ? 0 : 1"
        [appDroppablePredicate]="dndPredicate"
        (appDroppableDrop)="handleColumnDrop($event)"
      >
        @if (dndEnabled()) {
          <app-task
            *dndNestedFor="
              let task of tasks();
              let position = position;
              stateKey: project()?.id;
              positionKey: 'boardPosition';
              maxDepth: 0;
              droppableZIndex: 1;
              changes: tasksChanges;
              predicate: dndPredicate;
              preserveDraggedVisibility: true;
              topBuffer: true
            "
            class="block"
            [droppableZIndex]="1"
            [item]="task"
            [position]="position"
            (open)="openTask.emit(task)"
            (openSubtask)="openSubtask.emit($event)"
            (appClick)="clickTask.emit(task)"
            (appDblClick)="doubleClickTask.emit(task)"
          />
        } @else {
          @for (task of tasks(); track task.id; let index = $index) {
            <app-task
              class="block transition-opacity"
              [class.opacity-50]="draggedIdSet().has(task.id)"
              [droppableZIndex]="1"
              [item]="task"
              [position]="index"
              (open)="openTask.emit(task)"
              (openSubtask)="openSubtask.emit($event)"
              (appClick)="clickTask.emit(task)"
              (appDblClick)="doubleClickTask.emit(task)"
            />
          }
        }

        @if (quickTask(); as task) {
          <app-task-quick-form
            #quickForm
            class="block p-2"
            [showMore]="true"
            [task]="task"
            (close)="handleQuickFormClose()"
            (save)="handleQuickFormSave($event, quickForm)"
            (more)="handleQuickFormMore($event)"
          />
        } @else {
          <!-- `relative` is load-bearing. It has nothing to do with drop targeting (the DnD service
               picks zones by cached rects, so paint order is irrelevant there) — it is what gives this
               row its own `:hover` and cursor back. Mid-drag the list's collapsed drop slots hold
               invisible `.placeholder` elements that overflow across this row and still take part in
               the browser's hit-testing; positioning it paints it above them, as the task rows above
               already are. -->
          <app-button2
            class="block relative"
            appearance="secondary-ghost"
            size="l"
            align="start"
            [disabled]="!canAddTask()"
            (click)="handleNewTask()"
            appDroppable
            appDroppableHoverClass="rounded-md outline-4 outline-dashed outline-blue-200 outline-offset-[-4px]"
            [appDroppableDisabled]="!canAddTask()"
            [appDroppablePredicate]="newTaskDndPredicate"
            [appDroppableZIndex]="10"
            (appDroppableDrop)="handleNewTaskDrop($event)"
          >
            <app-icon name="plus" size="l" />
            Add a new task
          </app-button2>
        }
      </div>
    </div>
  </div>
}
